module.exports = {"previous":"&laquo; Anterior","next":"Siguiente &raquo;"};